export default "__VITE_ASSET__DJDGfB15__"